import { render, staticRenderFns } from "./Dialog_TeacherShopList.vue?vue&type=template&id=63f9c051&scoped=true&"
import script from "./Dialog_TeacherShopList.vue?vue&type=script&lang=js&"
export * from "./Dialog_TeacherShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9c051",
  null
  
)

export default component.exports